// extracted by mini-css-extract-plugin
export default {"hero-nav":"styles_hero-nav__Gagb6","nav-list":"styles_nav-list__bl4vX","list-item":"styles_list-item__3Ejmx"};